import isEmpty from 'ramda/es/isEmpty';
import { useContext } from 'react';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import useLogInAndSaveSearch from '~/hooks/srp/useLogInAndSaveSearch';
import HeartIcon from '~/icons/srp/HeartIcon';
import useSavedSearchApplied from './useSavedSearchApplied';

const SaveSearchButton = () => {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const saveSearch = useLogInAndSaveSearch();
  const savedSearchIsApplied = useSavedSearchApplied();
  const savedSearchIsDisabled = isEmpty(appliedFilters) || savedSearchIsApplied;

  return (
    <button
      type="button"
      className="bg-transparent border-none disabled:text-grey-3 p-0 relative text-blue-6"
      data-analytics-id="Search - Save Search Button"
      onClick={saveSearch}
      disabled={savedSearchIsDisabled}
    >
      <HeartIcon
        className="mr-[8px] relative top-[3px]"
        isSavedSearch={savedSearchIsApplied}
      />
      <span className="tl-header-xs m:tl-header-s">Save Search</span>
    </button>
  );
};

export default SaveSearchButton;
